module.exports = __webpack_public_path__ + "static/media/documentary.faeba6f2.svg";